<template>
  <o-dialog
    ref="dialog"
    :title="$t('components.reservation.actions.rebook.title')"
    :info="$t('components.reservation.actions.rebook.info')"
    :options="[
      { text: $t('general.back'), type: 'cancel' },
      { text: $t('reservation.rebook'), type: 'confirm', callback: confirm },
    ]"
    :portal="portal"
  >
    <div class="flex items-center space-x-2">
      <date-field
        v-model="timestamp"
        position-fixed
        :augmenter="Augmenters.timestamp"
        :min-date="minDate"
      />
      <o-dropdown placement="right">
        <o-button icon="preset" flat size="sm" />

        <template #content>
          <o-scroll class="max-h-2xs">
            <o-dropdown-item
              v-for="(date, index) in rebook"
              :key="index"
              @click="timestamp = date"
            >
              <template v-if="index >= rebook.length - 1">
                {{ $t('components.reservation.actions.rebook.twentyFourWeeks') }}
              </template>
              <template v-else>
                {{ $t('components.reservation.actions.rebook.week', { count: index + 1 }, index + 1) }}
              </template>
            </o-dropdown-item>
          </o-scroll>
        </template>
      </o-dropdown>
    </div>
    <div class="text-left mt-4">
      <o-field-group
        :label="$t('components.reservation.actions.rebook.keepNotes')"
        :info="$t('components.reservation.actions.rebook.keepNotesInfo')"
      >
        <toggle-field v-model="keepNotes" />
      </o-field-group>
    </div>
  </o-dialog>
</template>

<script setup lang="ts">
import { DateField, ToggleField } from '@/components/fields'

import ODropdown from '@/components/elements/dropdown/Dropdown.vue'
import ODropdownItem from '@/components/elements/dropdown/DropdownItem.vue'

import { augmenters as Augmenters } from '@/composables/useFieldAugmenters'

interface Props {
  reservation: Record<string, any>
  portal?: string | null
  loading?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  portal: null,
  loading: false,
})

const { $date, $panel } = useNuxtApp()

const dialog = ref<any>(null)

const timestamp = ref(Date.now() / 1000)
const keepNotes = ref(true)

const rebook = computed(() => {
  const result: any[] = []
  let date = props.reservation.date.date

  for (let i = 0; i < 12; i++) {
    date = $date.add(date, { weeks: 1 })
    result.push(date)
  }

  const twentyFourWeeks = $date.add(props.reservation.date.date, { weeks: 24 })
  result.push(twentyFourWeeks)

  return result
})

const minDate = computed(() => {
  return $date.add(props.reservation.date.date, { days: 1 })
})

watch(timestamp, () => {
  console.log(timestamp.value)
})

function open() {
  timestamp.value = Date.now() / 1000
  dialog.value.open()
}

function confirm() {
  let reservation = props.reservation

  if (!keepNotes.value) {
    reservation = props.reservation.clone()
    reservation.notes = ''
  }

  const path = '/appointment/create'
  const options = {
    props: { presets: { reservation, customer: props.reservation.customer, rebookReservation: props.reservation, date: new Date(timestamp.value * 1000) } },
  }
  $panel.create(path, options)
  dialog.value.close()
}

defineExpose({ open })
</script>
